import {
  type DeviceViewNodeEntity,
  isNodeEntity,
} from 'components/DeviceView/deviceViewTypes';
import { refreshDeviceViewEntityIds } from 'components/DeviceView/model/commands/refreshDeviceViewEntityIds';
import { refreshPathInspectorNodeIds } from 'components/Graph/commands/pathLookup/refreshPathInspectorNodeIds';
import { selectDeviceSns } from 'components/Graph/model/selectors/selectDeviceSns';
import { isPathLookupGraphMetadata } from '../GraphState';
import { getUpdatedEdgeData } from '../helpers/getUpdatedEdgeData';
import { getUpdatedNodesInGraph } from '../helpers/getUpdatedNodesInGraphs';
import type { GraphCommandFactory } from '../model/GraphCommandContext';
import { selectSnapshotToCompareId } from '../model/selectors/overlay/selectSnapshotToCompareId';
import { selectEdgeIds } from '../model/selectors/selectEdgeIds';

export const refreshDeviceExplorerEntities: GraphCommandFactory = (
  cmdContext,
  dispatch,
) => {
  return () => {
    const snapshotToCompareId = selectSnapshotToCompareId(
      cmdContext.getState(),
    );
    const edgeIds = selectEdgeIds(cmdContext.getState());
    const deviceSns = selectDeviceSns(cmdContext.getState());
    const { graphMetadata } = cmdContext.getState();
    const updatedNodeData = getUpdatedNodesInGraph(
      cmdContext.getState().graph.nodes,
      cmdContext.getState().graph.edges,
      graphMetadata,
      cmdContext
        .getDeviceView()
        .deviceViewEntities.filter(isNodeEntity)
        .map((entity) => entity.sn),
      snapshotToCompareId,
    );
    const updatedEdgeData = getUpdatedEdgeData(
      edgeIds,
      cmdContext.getState().graph,
      snapshotToCompareId,
    );
    cmdContext.getDeviceView().dispatch(refreshDeviceViewEntityIds, {
      updatedEdgeData,
      edgeIds,
      deviceSns,
      updatedNodeData,
    });

    const { activeDeviceViewEntityId, deviceViewEntities } =
      cmdContext.getDeviceView();

    if (activeDeviceViewEntityId === null) {
      return;
    }

    const activeDeviceViewEntityElement = deviceViewEntities.find(
      (entity) => entity.id === activeDeviceViewEntityId,
    )!.deviceViewElement;

    if (
      !isPathLookupGraphMetadata(graphMetadata) ||
      Object.keys(cmdContext.getDeviceView().deviceViewEntities).length === 0
    ) {
      return;
    }
    const foundDeviceViewEntity =
      activeDeviceViewEntityElement === 'node'
        ? deviceViewEntities.find(
            (entity): entity is DeviceViewNodeEntity =>
              isNodeEntity(entity) && entity.id === activeDeviceViewEntityId,
          )
        : null;

    dispatch(refreshPathInspectorNodeIds, {
      activeNodeId: foundDeviceViewEntity?.deviceId ?? null,
      activeNodeSn: foundDeviceViewEntity?.sn ?? null,
      deviceViewEntities,
      updatedNodeData,
    });
  };
};
